import { computed, defineComponent, ref } from 'vue';
export default defineComponent({
    props: {
        text: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['small', 'medium'].includes(value),
        },
    },
    emits: ['click'],
    setup(props, context) {
        const prefixCls = ref('my-button');
        const getClasses = computed(() => ({
            wrap: [`${prefixCls.value}`, `${prefixCls.value}-${props.size}`, props.disabled && `${prefixCls.value}-disabled`],
            body: [
                `${prefixCls.value}-body`,
                `${prefixCls.value}-body_${props.size}`,
                props.disabled && `${prefixCls.value}-disabled-body`,
            ],
            title: [
                `${prefixCls.value}-txt`,
                `${prefixCls.value}-txt__${props.size}`,
                props.disabled && `${prefixCls.value}-disabled-txt`,
            ],
        }));
        /** 对外响应的事件 */
        const listener = (event) => {
            if (!props.disabled) {
                context.emit('click', event);
            }
            return null;
        };
        return { getClasses, listener };
    },
});
